import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "./button";

type Props = {
  page: number; pageSize: number; total: number;
  onChange: (page: number, pageSize: number) => void;
  pageSizeOptions?: number[];
};

/** 项目 shadcn 风格分页器，支持页码和每页条数切换。 */
export function Pagination({ page, pageSize, total, onChange, pageSizeOptions = [20, 50, 100] }: Props) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const currentPage = Math.min(Math.max(page, 1), pages);
  const pageStart = pages <= 5 ? 1 : currentPage <= 3 ? 1 : currentPage >= pages - 2 ? pages - 4 : currentPage - 2;
  const visiblePages = Array.from({ length: Math.min(5, pages) }, (_, index) => pageStart + index);
  return <nav className="fm-shadcn-pagination" aria-label="分页导航">
    <span className="fm-shadcn-pagination-total">共 {total} 条</span>
    <Button variant="outline" size="icon" aria-label="上一页" disabled={currentPage <= 1} onClick={() => onChange(currentPage - 1, pageSize)}><ChevronLeft aria-hidden="true" /></Button>
    <span className="fm-shadcn-pagination-pages">{visiblePages.map((pageNumber) => <Button key={pageNumber} variant={pageNumber === currentPage ? "default" : "outline"} size="icon" aria-label={`第 ${pageNumber} 页`} aria-current={pageNumber === currentPage ? "page" : undefined} onClick={() => onChange(pageNumber, pageSize)}>{pageNumber}</Button>)}</span>
    <Button variant="outline" size="icon" aria-label="下一页" disabled={currentPage >= pages} onClick={() => onChange(currentPage + 1, pageSize)}><ChevronRight aria-hidden="true" /></Button>
    <select aria-label="每页条数" value={pageSize} onChange={(event) => onChange(1, Number(event.target.value))}>{pageSizeOptions.map((option) => <option key={option} value={option}>{option} 条/页</option>)}</select>
  </nav>;
}
